import { useNavigate } from "react-router-dom-v5-compat";
import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreTripsComponent } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { PATH_HOME } from "@hopper-b2b/utilities";
import clsx from "clsx";
import styles from "./NoTripResults.module.scss";

export type NoTripResultsComponentProps = {
  title: string;
  subtitle: string;
  actionText: string;
  action: () => void;
  actionClassname?: string;
};

export type NoTripResultsProps = {
  hasError: boolean;
};

export const NoTripResults = ({ hasError }: NoTripResultsProps) => {
  const { t } = useI18nContext();
  const navigate = useNavigate();

  if (hasError) {
    return (
      <NoTripResultsComponent
        title={t("tripsLoadErrorTitle")}
        subtitle={t("tripsLoadErrorSubtitle")}
        actionText={t("tripsLoadErrorButtonTitle")}
        action={() => navigate(PATH_HOME)}
      />
    );
  }

  return (
    <NoTripResultsComponent
      title={t("noTripsFound")}
      subtitle={t("noTripsSubtitle")}
      actionText={t("noTripsButtonTitle")}
      action={() => navigate(PATH_HOME)}
    />
  );
};

export const NoTripResultsComponent = ({
  title,
  subtitle,
  actionText,
  action,
  actionClassname,
}: NoTripResultsComponentProps) => {
  const [block, cn] = useModuleBEM(styles, CoreTripsComponent.NoTripResults);
  return (
    <div className={block}>
      <div className={cn("title")}>
        <h1>{title}</h1>
      </div>
      <div className={cn("subtitle")}>
        <h2>{subtitle}</h2>
      </div>
      <button className={clsx(actionClassname, cn("button"))} onClick={action}>
        {actionText}
      </button>
    </div>
  );
};
